export function setTime(time: any) {
    var date = new Date(time)
    let y = date.getFullYear() + '-';
    let m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    let d = date.getDate() + ' ';
    return y + m + d
}